export function EPSG(projection_number) {
    if (typeof projection_number === 'string' && !Number.isInteger(Number(projection_number)))
        throw new Error("Passed projection is not valid: " + projection_number);
    return 'EPSG:' + projection_number.toString();
}
